import { useWorkspace } from '@/features/workspaces/hooks';
import { TextArea } from '@/lib';
import { useGetUnifiedProfileQuery } from '@/services/endpoints/unifiedProfiles';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { UnifiedProfileSection } from '../../common';

export const UnifiedProfileDetailsSection: FC = () => {
  const { t } = useTranslation('unifiedProfile');

  const { id: unifiedProfileId } = useParams<{ id: string }>();
  const workspace = useWorkspace();

  const { data: unifiedProfile } = useGetUnifiedProfileQuery({
    unifiedProfileId,
    workspaceId: workspace.id,
  });

  const fullName = useMemo(() => {
    const firstName = unifiedProfile?.firstName[0];
    const lastName = unifiedProfile?.lastName[0];

    return [firstName, lastName].filter(Boolean).join(' ');
  }, [unifiedProfile?.firstName, unifiedProfile?.lastName]);

  return (
    <UnifiedProfileSection>
      <div className='border-b border-quaternary-200 pb-4'>
        {fullName && <h1 className='text-6xl font-semibold leading-[72px] text-brand-600'>{fullName}</h1>}
        <p className='text-tertiary-600'>{unifiedProfile.email}</p>
      </div>

      <div className='flex flex-col gap-1.5 pt-6'>
        <h2 className='text-sm font-medium text-secondary-700'>{t('profileDescription')}</h2>
        <TextArea
          id='description'
          className='border-primary-border bg-quaternary-50 px-3.5 py-3 text-quaternary-500 shadow-[0_1px_2px_0_rgba(10,13,18,0.05)] first-letter:capitalize'
          defaultValue={unifiedProfile?.description[0] ?? t('descriptionPlaceholder')}
          disabled
        />
      </div>
    </UnifiedProfileSection>
  );
};
